module.exports = "<div #pluginContainer></div>"